import React from "react";
import { Select } from "antd";

export default function SapTypeComponent({ onChange, value, all }) {
	return (
		<Select
			showSearch={true}
			optionFilterProp='children'
			style={{ width: "100%" }}
			size='large'
			placeholder='Please Select Type'
			value={value}
			onChange={onChange}
			allowClear
		>
			<Select.Option key='New' value='New'>
				New (SAP ID)
			</Select.Option>
			<Select.Option key='Modification' value='Modification'>
				Modification (SAP ID)
			</Select.Option>
			<Select.Option key='Transfer of ID' value='Transfer of ID'>
				Transfer of ID
			</Select.Option>
		</Select>
	);
}
